import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function Advocates() {
  const founder = {
    name: "Dr. Elena Thorne",
    role: "LEAD CONSERVATIONIST",
    credentials: "PHD ECOLOGY / REFUGE STEWARD",
    bio: "Dedicated to the preservation of Pacific Northwest coastal ecosystems with over two decades of field research and wildlife advocacy experience.",
    quote: "Protection is not a passive act; it is a deliberate commitment to the future of our wild neighbors. Every voice raised for the refuge matters.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/elena_thorne_portrait.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/elena_thorne_portrait.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/elena_thorne_portrait.webp-wvc-sizes"
  };
  const team = [{
    name: "Marcus Chen",
    role: "HABITAT SPECIALIST",
    credentials: "MS BIOLOGY / FIELD RESEARCHER",
    bio: "Expert in sea bird nesting patterns and habitat restoration, focusing on the unique needs of Protection Island's avian populations.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/marcus_chen_portrait.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/marcus_chen_portrait.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/marcus_chen_portrait.webp-wvc-sizes"
  }, {
    name: "Sarah Jenkins",
    role: "COMMUNITY OUTREACH",
    credentials: "BA ENVIRONMENTAL POLICY / ADVOCATE",
    bio: "Bridges the gap between scientific research and public awareness, empowering local communities to protect Dungeness National Wildlife Refuge.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/sarah_jenkins_portrait.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/sarah_jenkins_portrait.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/sarah_jenkins_portrait.webp-wvc-sizes"
  }, {
    name: "David Miller",
    role: "REFUGE LIAISON",
    credentials: "MBA NONPROFIT MGMT / STRATEGIST",
    bio: "Coordinates strategic partnerships and educational initiatives to ensure the long-term sustainability of our protected coastal lands.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/david_miller_portrait.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/david_miller_portrait.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722645/img/david_miller_portrait.webp-wvc-sizes"
  }];
  return <section data-section-id="4558" id="meet-the-advocates" className="bg-slate-50 text-slate-900 py-20 md:py-28 px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="max-w-3xl mb-16 md:mb-20">
          <p className="font-default text-xs uppercase tracking-widest text-blue-600 mb-6">
            02 / Our Team
          </p>
          <h2 className="font-default font-semibold text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-slate-900 mb-6">
            The guardians of our refuges.
          </h2>
          <p className="font-default text-base text-slate-700 leading-relaxed max-w-2xl">
            A dedicated collective of biologists, educators, and advocates
            united by a single mission: to inform the public on how to protect 
            our wildlife and sea bird refuges, ensuring these vital habitats 
            thrive for generations to come.
          </p>
        </div>

        <Separator className="bg-slate-200 mb-12 md:mb-16" />

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-0 gap-y-12 md:gap-y-16 relative">
          {}
          <article data-index={0} className="md:col-span-2 lg:pr-10 lg:border-r lg:border-slate-200">
            <div className="relative group overflow-hidden mb-6 rounded-lg shadow-md">
              <div className="aspect-[3/4] w-full overflow-hidden bg-slate-200">
                <img src={founder.image} data-wvc-srcset={founder.srcset} data-wvc-sizes={founder.sizes} alt={founder.name} loading="lazy" decoding="async" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-blue-600/0 group-hover:bg-blue-600/10 transition-colors duration-500 pointer-events-none" />
              </div>
              <div className="absolute inset-0 flex items-end p-6 md:p-10 pointer-events-none">
                <p className="font-default italic text-lg md:text-xl leading-snug text-slate-900 max-w-md bg-white/80 backdrop-blur-sm p-5 border-l-2 border-blue-600 rounded-lg">
                  &ldquo;{founder.quote}&rdquo;
                </p>
              </div>
            </div>
            <div className="space-y-3">
              <p className="font-default text-[11px] uppercase tracking-widest text-blue-600">
                {founder.role}
              </p>
              <h3 className="font-default font-semibold text-[26px] leading-tight text-slate-900">
                {founder.name}
              </h3>
              <p className="font-default text-[13px] uppercase tracking-wide text-slate-600">
                {founder.credentials}
              </p>
              <p className="font-default text-sm text-slate-700 leading-relaxed max-w-md pt-1">
                {founder.bio}
              </p>
              <Link to="/GetInvolvedPage" className="inline-flex items-center gap-1.5 font-default text-[11px] uppercase tracking-widest text-slate-900 hover:text-blue-600 transition-colors pt-3">
                Learn More
                <ArrowUpRight className="size-3" />
              </Link>
            </div>
          </article>

          {}
          {team.map((member, i) => <article data-index={i + 1} key={member.name} className={`px-0 lg:px-6 ${i < team.length - 1 ? "lg:border-r lg:border-slate-200" : ""} ${i % 2 === 0 ? "lg:mt-8" : "lg:-mt-2"}`}>
              <div className="relative group overflow-hidden mb-5 rounded-lg shadow-md">
                <div className="aspect-[3/4] w-full overflow-hidden bg-slate-200">
                  <img src={member.image} data-wvc-srcset={member.srcset} data-wvc-sizes={member.sizes} alt={member.name} loading="lazy" decoding="async" className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-blue-600/0 group-hover:bg-blue-600/10 transition-colors duration-500 pointer-events-none" />
                </div>
              </div>
              <div className="space-y-2.5">
                <p className="font-default text-[11px] uppercase tracking-widest text-blue-600">
                  {member.role}
                </p>
                <h3 className="font-default font-semibold text-[22px] leading-tight text-slate-900">
                  {member.name}
                </h3>
                <p className="font-default text-[13px] uppercase tracking-wide text-slate-600 leading-relaxed">
                  {member.credentials}
                </p>
                <p className="font-default text-sm text-slate-700 leading-relaxed pt-1">
                  {member.bio}
                </p>
                <Link to="/GetInvolvedPage" className="inline-flex items-center gap-1.5 font-default text-[11px] uppercase tracking-widest text-slate-900 hover:text-blue-600 transition-colors pt-3">
                  Learn More
                  <ArrowUpRight className="size-3" />
                </Link>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}